import { useMutation } from '@tanstack/react-query';

import { useUseCases } from '../../../UseCaseProvider';
import quotaQueryKeys from '../queryKeys';

export const useNotifyAdminForQuotaMutation = (onSuccess: VoidFunction) => {
  const { notifyAdmin } = useUseCases();

  return useMutation({
    mutationKey: quotaQueryKeys.dataCreditsNotifyAdmin(),
    mutationFn: notifyAdmin,
    onSuccess,
  });
};
